export const EDITOR_BOZZE = 'editor-bozze/'
export const AREA_STAMPA = EDITOR_BOZZE + 'area-stampa/'
export const AREA_STAMPA_SEARCH_PRODOTTI = AREA_STAMPA + 'searchprodotti/'
export const AREA_STAMPA_CONFERMA_ALL = AREA_STAMPA + 'conferma-all/'
export const AREA_STAMPA_DATI_PRODOTTO = EDITOR_BOZZE + 'area-stampa-data/'
export const PANTONI = EDITOR_BOZZE + 'pantoni/'